module.exports = __webpack_public_path__ + "static/media/Febrina.4a17d1cf.jpeg";